import { Component } from '@angular/core';
import { legendFormatter } from '../../helpers/legend-formatter';
import { symbolIcon } from '../../icon-paths';
import { LineChartComponent } from '../line-chart/line-chart.component';
import yAxisMaxValue from '../../helpers/y-axis-max-value';
import { colorsScss } from '../../helpers/colors-scss';

@Component({
  selector: 'studio-comparison-chart',
  templateUrl: '../../templates/chart.component.html',
  styleUrls: [
    '../../styles/chart.scss',
    '../../styles/tooltip.scss',
    './comparison-chart.component.scss',
  ],
})
export class ComparisonChartComponent extends LineChartComponent {
  createChart() {
    const baseConfig = this.chartConfig();
    // Create a new array, don't mutate the array order
    const chartData = [...this.chartData];

    this.options = {
      ...baseConfig,
      grid: {
        ...baseConfig.grid,
        left: 45,
        right: 45,
      },
      color: [colorsScss.warningDark, colorsScss.primary],
      legend: {
        ...baseConfig.legend,
        data: chartData.map((data) => data.name),
      },
      yAxis: chartData.reverse().map((data, index) => ({
        name: legendFormatter(data.name, data.unit),
        nameLocation: 'middle',
        nameTextStyle: {
          fontWeight: 400,
        },
        nameGap: 48,
        minInterval: 1,
        splitNumber: 5,
        type: 'value',
        position: index === 0 ? 'right' : 'left',
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: colorsScss.grey,
          },
          show: index !== 0,
        },
        max: (value) => yAxisMaxValue(value.max, data.type),
        axisLabel: {
          formatter: (value) => this.chartValueFormatterService.formatValue(value, data.type),
        },
      })),
      // Drawn in order, the primary line needs to be last to appear at the highest level
      series: this.chartData.reverse().map((data, index) => ({
        data: data.seriesData,
        name: data.name,
        type: 'line',
        symbolSize: 10,
        symbol: symbolIcon,
        lineStyle: {
          width: 3,
        },
        yAxisIndex: index,
      })),
    };
  }
}
